
      import ArrowDown from './arrow-down.vue'
      import type { App, Plugin } from 'vue'

      export const ArrowDownPlugin: Plugin = {
        install(app: App) {
          app.component('ArrowDown', ArrowDown)
        },
      }
      export { ArrowDown }
      